import { Box, Container, Heading, VStack, Image } from "@chakra-ui/react";
import React from "react";
import useSite from "../../../hooks/use-site";
import { wpStyles } from "../../../theme/wp-styles";
import Categories from "./Categories";
import { formatBlogDate } from "../../../support/functions";
import blogMaskBackImg from "../../../assets/img-blog-mask-black.svg";
import frontImg from "../../../assets/img-mask-front.svg";
import maskImg from "../../../assets/img-mask.svg";

const SinglePostBanner = () => {
  const site = useSite();

  const {
    post: { title, date },
  } = site;

  const postDate = new Date(date);

  return (
    <Box
      pt={{
        base: 8,
        md: 16,
        lg: 20,
      }}
      pb={{
        base: 8,
        md: 16,
        lg: 32,
      }}
      borderTop="1px"
      borderBottom="1px"
      bg="green.400"
      borderColor={wpStyles.colors.border}
      overflow="hidden"
      position="relative"
      zIndex="1"
    >
      <Container position="relative" zIndex="2">
        <VStack align="stretch" spacing={4} textAlign="center">
          <Box>
            <Categories />
            <Box color="white" fontSize="sm">
              {formatBlogDate(postDate)}
            </Box>
          </Box>
          <Heading
            fontSize={{
              base: wpStyles.fontSize.xl,
              md: wpStyles.fontSize.xl,
              lg: wpStyles.fontSize.colossal,
            }}
            as="h1"
            mb="0"
            color="white"
            fontWeight="bold"
            maxW="500px"
            mx="auto"
            textAlign="center"
          >
            {title}
          </Heading>
        </VStack>
      </Container>
      <BlogMaskedImage />
    </Box>
  );
};

const BlogMaskedImage = () => {
  return (
    <Box
      position="absolute"
      w="1300px"
      mx="auto"
      top="0"
      left="0"
      right="0"
      bottom="0"
    >
      <Box
        position="absolute"
        top="-100px"
        left="0"
        opacity="0.10"
        maxW={{ base: "80%", lg: "100%" }}
      >
        <Image
          src={blogMaskBackImg.src}
          width={"475px"}
          height={"475px"}
          className="mask-back"
          alt="Masking Image Back"
        />
      </Box>
      <Box
        position="absolute"
        bottom="-350px"
        right="200px"
        opacity="0.1"
        maxW={{ base: "80%", lg: "100%" }}
      >
        <Image
          src={blogMaskBackImg.src}
          width={"700px"}
          height={"700px"}
          className="mask-back"
          alt="Masking Image Back"
        />
      </Box>
      <Box
        position="absolute"
        top="-100px"
        right="0px"
        opacity="0.1"
        maxW={{ base: "80%", lg: "100%" }}
      >
        <Image
          src={blogMaskBackImg.src}
          width={"350px"}
          height={"350px"}
          className="mask-back"
          alt="Masking Image Back"
        />
      </Box>
    </Box>
  );
};

export default SinglePostBanner;
